import { z } from "zod";
export const ControlledAiSourceKindSchema = z.enum(["TEXT", "VOICE_TRANSCRIPT", "FILE_METADATA"]);
export const ControlledAiExtractionCandidateV1Schema = z
    .object({
    schemaVersion: z.literal("controlled-ai-extraction-candidate.v1.0"),
    candidateId: z.string().min(1),
    agencyId: z.string().min(1),
    projectId: z.string().min(1),
    sourceKind: ControlledAiSourceKindSchema,
    sourceRef: z.string().min(1),
    proposedFields: z.record(z.string(), z.unknown()),
    activationStatus: z.literal("CANDIDATE"),
    modelRef: z.string().min(1),
    promptVersion: z.string().min(1),
    createdAt: z.string().datetime(),
})
    .strict();
export function assertCandidateNeverAutoActivates(candidate) {
    if (candidate.activationStatus !== "CANDIDATE") {
        throw new Error("ai_truth_activation_forbidden");
    }
    return candidate;
}
//# sourceMappingURL=extraction-candidate.js.map